module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sale2-de2f084f95d42df4f2e47a0cefed7c66.svg";